export default "__VITE_ASSET__a4a6a73a__"